<template>
  <fieldset
    v-if="options?.length > 0"
    ref="fieldsetRef"
    :class="{ required: required }"
    :aria-invalid="!!errorMessage"
    :aria-describedby="`${id}-error`"
  >
    <legend class="bold">{{ label }}{{ required ? " *" : "" }}</legend>
    <FormCheckbox
      v-for="option in options"
      :id="prefixId(option.id)"
      :key="option._uid"
      :name="option.id"
      :label="option.label"
      @change="handleChange"
    />
    <p
      v-if="!!errorMessage"
      :id="`${prefixId(id)}-error`"
      role="alert"
      class="form-error"
    >
      {{ errorMessage }}
    </p>
  </fieldset>
</template>

<script setup>
import { useField } from "vee-validate";

const props = defineProps({
  options: {
    type: Array,
    required: false,
    default: () => {
      return [];
    },
  },
  label: {
    type: String,
    required: false,
    default: "",
  },
  id: {
    type: String,
    required: false,
    default: "",
  },
  rules: {
    type: [String, Object],
    required: false,
    default: "",
  },
  required: {
    type: Boolean,
    required: false,
  },
});

const uuid = useId();

const rules = computed(() => {
  if (props.rules) return props.rules;
  if (props.required) return "required";
});
const { value: checkboxesValue, errorMessage } = useField(props.id, rules);
const fieldsetRef = ref(null);

const updateCheckedState = () => {
  const checkboxes = Array.from(
    fieldsetRef.value?.querySelectorAll('input[type="checkbox"]') ?? []
  );
  const isChecked = checkboxes.some((item) => item.checked);
  checkboxesValue.value = isChecked ? true : false;
};

const handleChange = () => {
  updateCheckedState();
};

const prefixId = (value) => {
  return `${uuid}-${value}`;
};
</script>

<style lang="scss" scoped>
fieldset {
  margin-top: 2rem;
  legend {
    font-size: 1.5em;
  }
  div {
    margin-top: 0.5rem;
  }
} 
</style>
